import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_INVOICING',
    icon: 'FileTextIcon',
    action: constants.action.permissionAllowInvoicing,
    resource: constants.resource.invoicing,
    children: [
      {
        title: 'DEBTIA_INVOICES',
        route: 'invoices-list',
        action: constants.action.permissionAllowInvoicing,
        resource: constants.resource.invoicing,
      },
      {
        title: 'DEBTIA_CREATE_INVOICE',
        route: 'create_invoice',
        action: constants.action.permissionAllowInvoicing,
        resource: constants.resource.invoicing,
      },
    ],
  },
]
